// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reply-form[data-v-48f02b67]{margin-bottom:2rem}.reply-form-content[data-v-48f02b67]{padding:0}.reply-input-wrapper[data-v-48f02b67]{display:flex;flex-direction:column}.reply-textarea[data-v-48f02b67]{line-height:1.5;min-height:2.5rem}.reply-textarea[data-v-48f02b67]:focus{min-height:5rem}.reply-buttons[data-v-48f02b67]{display:flex;justify-content:flex-end}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
